/**
 * The error codes of this area of the admin API and the auth routes (see
 * `./index.ts`). One entry per message the backend can send; the panel
 * translates `errors.<code>`.
 */
export const TENANT_ERROR_CODES = [
  'ACTIVITY_LOG_ROLE_REQUIRED',
  'CABINET_CONFIGURATION_ROLE_REQUIRED',
  'CABINET_CREDIT_ROLE_REQUIRED',
  'CABINET_KEYS_ROLE_REQUIRED',
  'CONFIGURATION_LIST_ROLE_REQUIRED',
  'DASHBOARD_ROLE_REQUIRED',
  'DEFAULT_CONFIGURATIONS_ROLE_REQUIRED',
  'INVALID_DEFAULT_CONFIGURATIONS',
  'INVALID_FILTER_VALUE',
  'LOCATION_HAS_CABINETS',
  'MEMBERS_ROLE_REQUIRED',
  'ONLY_PLATFORM_ADMINS_CHANGE_TENANT_SLUG_OR_STATUS',
  'ONLY_PLATFORM_ADMINS_MANAGE_PLATFORM_SETTINGS',
  'ONLY_PLATFORM_ADMINS_MANAGE_TENANTS',
  'ONLY_PLATFORM_ADMINS_SEE_SYSTEM_INFO',
  'ROUNDS_ROLE_REQUIRED',
  'TENANT_SETTINGS_ROLE_REQUIRED',
  'TENANT_SLUG_TAKEN',
  'UNKNOWN_LIST_FIELD',
  'UNSUPPORTED_FILTER_OPERATOR',
] as const
